"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2; /**
                     * Copyright 2013-present, Novivia, Inc.
                     * All rights reserved.
                     */

var _Alert = require("react-bootstrap-components/Alert");

var _Alert2 = _interopRequireDefault(_Alert);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FeedbackAlert = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(FeedbackAlert, _Component);

  function FeedbackAlert() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FeedbackAlert);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FeedbackAlert.__proto__ || (0, _getPrototypeOf2.default)(FeedbackAlert)).call.apply(_ref, [this].concat(args))), _this), _this.renderContent = function (content, messageOne, messageMany) {
      if (Array.isArray(content)) {
        // If the content is an empty array, render nothing.
        if (content.length === 0) {
          return null;
        }

        // If there is only one message in the content, render the prefix
        // `messageOne` followed by that message.
        if (content.length === 1) {
          return [messageOne || null, content[0]];
        }

        // If there are multiple messages in the content, render the prefix
        // `messageMany` followed by a list of the messages.
        return [_react2.default.createElement(
          "p",
          { key: "messages" },
          messageMany || messageOne || null
        ), _react2.default.createElement(
          "ul",
          { key: "content" },
          content.map(function (item, index) {
            return _react2.default.createElement(
              "li",
              { key: index },
              item
            );
          })
        )];
      }

      // If the content is not an array, display the content itself.
      return content;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /**
   * Render the message or the list of messages.
   * @param  {Array|String} content     Message or list of messages to display.
   * @param  {String}       messageOne  Message to display before the content
   *                                    if there is only one item.
   * @param  {String}       messageMany Message to display before the content
   *                                    if there are many items.
   * @return {ReactElement}             Rendered content.
   */


  (0, _createClass3.default)(FeedbackAlert, [{
    key: "render",
    value: function render() {
      // Display a neutral message by default.
      var bsStyle = void 0;
      var content = null;

      var __ = this.context.__;

      // Find out which type of message to display, if any.

      if (this.props.errors) {
        // Error message(s).
        bsStyle = "danger";
        content = this.renderContent(this.props.errors, (this.props.messages.errors.one || __("errors::oneError")) + ": ", (this.props.messages.errors.many || __("errors::manyErrors")) + ": ");
      } else if (this.props.info) {
        // Neutral message(s).
        bsStyle = "info";
        content = this.renderContent(this.props.info, this.props.messages.info.one, this.props.messages.info.many);
      } else if (this.props.success) {
        // Success message(s).
        bsStyle = "success";
        content = this.renderContent(this.props.success, this.props.messages.success.one, this.props.messages.success.many);
      } else if (this.props.warnings) {
        // Warning message(s).
        bsStyle = "warning";
        content = this.renderContent(this.props.warnings, (this.props.messages.warnings.one || __("general::warning")) + ": ", this.props.messages.warnings.many);
      }

      // Display the Bootstrap alert. If `content` is null, it will not display.
      return _react2.default.createElement(
        _Alert2.default
        // Uses the same styles as Bootstrap to define the alert style.
        ,
        { bsStyle: bsStyle,
          permanent: this.props.permanent,
          onHide: this.props.onHide
        },
        content
      );
    }
  }]);
  return FeedbackAlert;
}(_react.Component), _class.propTypes = {
  // List of errors to display.
  errors: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),

  // Neutral message to display.
  info: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),

  // Override prefix messages.
  messages: _propTypes2.default.shape({
    errors: _propTypes2.default.shape({
      many: _propTypes2.default.string,
      one: _propTypes2.default.string
    }),

    info: _propTypes2.default.shape({
      many: _propTypes2.default.string,
      one: _propTypes2.default.string
    }),

    success: _propTypes2.default.shape({
      many: _propTypes2.default.string,
      one: _propTypes2.default.string
    }),

    warnings: _propTypes2.default.shape({
      many: _propTypes2.default.string,
      one: _propTypes2.default.string
    })
  }),

  // Whether the alert message can be closed (dismissed) or not.
  permanent: _propTypes2.default.bool,

  // Success message to display.
  success: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),

  // List of warnings to display.
  warnings: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),

  // Callback when the alert is closed.
  onHide: _propTypes2.default.func
}, _class.contextTypes = {
  __: _propTypes2.default.func.isRequired
}, _class.defaultProps = {
  messages: {
    errors: {},
    info: {},
    success: {},
    warnings: {}
  }
}, _temp2);
exports.default = FeedbackAlert;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/react-components/FeedbackAlert.jsx
// module id = 126
// module chunks = 6